var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientInChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28956 5.63938C4.38956 4.99938 4.16956 3.75938 4.79956 2.84938C5.42956 1.94938 6.67956 1.72938 7.58956 2.35938C8.48956 2.99938 8.70956 4.23938 8.07956 5.14938C7.43956 6.04938 6.19956 6.26938 5.28956 5.63938ZM16 18.9997C16 17.8951 15.1046 16.9994 14 16.9994H8.43945C6.95945 16.9994 6.12956 15.9194 5.90956 14.4594L4.58348 6.82878C4.50023 6.34974 4.08447 6 3.59825 6H3.55673C2.96072 6 2.49702 6.51807 2.56285 7.11044L3.43956 15C3.81956 17.44 4.06 21 8 21H14C15.1046 21 16 20.1043 16 18.9997V18.9997ZM18 13H11.5C11.5 13 10.3333 10 10 9C9.66667 8 9.24945 7.01354 8 7C6.5 7 5.87978 8.50725 6 9.5C6.06055 10 6.81956 13.5594 6.81956 13.5594C7.09956 14.9794 8.32956 15.9994 9.76956 15.9994L16.5 16L18 21H20L18 13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInChair);
export default __webpack_public_path__ + "static/media/client-in-chair.9c7c1d18f1f7fb7e183d4938b5ca863e.svg";
export { ForwardRef as ReactComponent };